import LFCDialogTitle from '_components/feedback/LFCDialogTitle';
import {useCallback, useEffect, useState} from 'react';

import {Dialog, DialogContent, Divider} from '@mui/material';

import {MainPanel} from './MainPanel';
import {SearchPanel} from './SearchPanel';
import {CloudDistanceDialogParams, SearchConditions} from './types';

/**
 * 引数
 */
interface Props {
  open: boolean;
  onClose: () => void;
  params: CloudDistanceDialogParams;
}

export const CloudDistanceDig = ({open, onClose, params}: Props) => {
  const [paramSearchConditions, setParamSearchConditions] = useState<SearchConditions>({
    selectDateFrom: params.selectDateFrom,
    selectDateTo: params.selectDateTo,
    work: params.work,
    deviceid: params.deviceid,
    judge: params.judge,
    map: params.map,
    searchType: params.searchType
  });

  //確定条件
  const [fixSearchConditions, setFixSearchConditions] = useState<SearchConditions | null>(null);

  /**
   * 検索処理
   */
  const handleSearch = useCallback((searchConditions: SearchConditions) => {
    //検索条件FIX
    setFixSearchConditions({...searchConditions}); //同じ条件で再検索できるように新しいオブジェクトにして入れる
  }, []);

  useEffect(() => {
    if (open) {
      setParamSearchConditions({
        selectDateFrom: params.selectDateFrom,
        selectDateTo: params.selectDateTo,
        work: params.work,
        deviceid: params.deviceid,
        judge: params.judge,
        map: params.map,
        searchType: params.searchType
      });
    } else {
      setFixSearchConditions(null);
    }
  }, [open]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth={false} fullWidth>
      <LFCDialogTitle onClose={onClose}>{params.pageName}</LFCDialogTitle>
      <DialogContent>
        <SearchPanel searchConditions={paramSearchConditions} onSearch={handleSearch} />
        <Divider sx={{margin: '0.5em 0'}} />
        <MainPanel searchConditions={fixSearchConditions} />
      </DialogContent>
    </Dialog>
  );
};
